import { Box, useDisclosure, VStack } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { DynamicListType } from "../../../../../common/types/campaign";
import CampaignExitCriteria from "../../exit-criteria/CampaignExitCriteria";
import CommonDrawer from "../../components/CommonDrawer";
import { useSelector } from "react-redux";
import { selectCampaign } from "../../campaignSlice";
import SectionTitle from "./components/SectionTitle";
import { DISABLED_EDIT_CLASSNAME } from "../../../../../common/constants/campaign";

export default function CampaignExitSection({
  data,
  errorText,
  readonly,
  onChange,
}: {
  data: DynamicListType | null;
  errorText: string;
  readonly: boolean;
  onChange: (data: DynamicListType | null) => void;
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();

  const [localData, setLocalData] = useState<DynamicListType | null>(null);

  const {
    campaignDetails: {
      data: { active },
    },
    activeErrorCheck,
  } = useSelector(selectCampaign);

  useEffect(() => {
    setLocalData(data);
  }, [data]);

  return (
    <VStack alignItems="flex-start">
      <SectionTitle
        title="Exit Criteria"
        readonly={readonly}
        btnRef={btnRef}
        onOpen={onOpen}
        active={active}
        activeErrorCheck={activeErrorCheck}
        errorText={errorText}
      />

      <CampaignExitCriteria
        showCheckOptions
        data={data}
        onChange={() => {}}
        isReadOnly={true}
      />

      <CommonDrawer
        size="xl"
        title="Exit Criteria"
        btnRef={btnRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <Box className={readonly ? DISABLED_EDIT_CLASSNAME : ""} w="100%">
          <CampaignExitCriteria
            data={localData}
            onChange={onChange}
            isReadOnly={false}
            activeErrorCheck={activeErrorCheck}
            showCheckOptions
          />
        </Box>
      </CommonDrawer>
    </VStack>
  );
}
